
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/carbonEmission",
      function () {
        return require("private-next-pages/carbonEmission.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/carbonEmission"])
      });
    }
  